/* eslint-disable react/no-unescaped-entities */
import { Grid, Typography } from '@lamimed/pantheon';
import Head from 'next/head';

import { Header } from 'components/Header';

import * as S from './styles';

export const CookiesPolicy: React.FC = () => {
  return (
    <>
      <Head>
        <title key="title">Cookies policy | Lami </title>

        <meta
          key="description"
          name="description"
          content="Cookies Policy Lami. Prenota subito in pochi click una video visita o una visita domiciliare con i nostri specialisti direttamente da casa tua."
        />
      </Head>

      <Header />

      <S.Wrapper>
        <Grid.Wrapper>
          <Typography
            variant="heading_1"
            color="text__highlight"
            as="h1"
            textAlign="center"
            marginBottom="medium"
          >
            Cookie policy
          </Typography>

          <Typography marginBottom="medium">
            La presente Cookie Policy ha lo scopo di informare sul tipo di
            cookie utilizzati dal sito www.lamimed.it , oltre che di fornire
            informazioni su come sia possibile gestire i cookie.
          </Typography>

          <Typography marginBottom="medium">
            I cookie sono piccoli file di testo contenenti pacchetti di
            informazioni, che vengono memorizzati sul computer o sul dispositivo
            mobile dell’utente ogni volta che questi visitano un sito web
            attraverso un browser o una web app.
          </Typography>

          <Typography marginBottom="medium">
            Il Titolare utilizza cookie tecnici e cookie analitici (come meglio
            specificato nel prosieguo), al fine di garantire il corretto
            funzionamento della Piattaforma e migliorarne l’utilizzo. Grazie ai
            cookie è possibile garantire una navigazione più agevole.
          </Typography>

          <Typography marginBottom="medium">
            Il Titolare può modificare o aggiornare periodicamente la presente
            Cookie Policy: le modifiche o gli aggiornamenti saranno efficaci e
            portati a conoscenza degli utenti non appena adottati, mediante
            pubblicazione sul sito. Gli utenti sono pertanto invitati a
            controllare periodicamente la presente Cookie Policy.
          </Typography>

          <Typography marginBottom="medium">
            I dati personali dei Visitatori raccolti attraverso i cookie saranno
            trattati dal Titolare conformemente all’Informativa Privacy, nonché
            nel rispetto del GDPR, del D.Lgs. 196/2003 e delle linee guida
            dell’Autorità Garante per la protezione dei dati personali.
          </Typography>

          <Typography marginBottom="medium">
            Il trattamento dei dati personali svolto attraverso i cookie tecnici
            non richiede il consenso degli utenti.
          </Typography>

          <Typography marginBottom="medium">
            Utilizzando questo sito accettate il posizionamento dei cookie sul
            vostro computer in conformità con i termini della presente policy.
            Se non desiderate accettare i cookie da questo sito per favore o
            disabilitate i cookies o astenetevi dall'uso di questo sito.
          </Typography>

          <Typography
            variant="heading_2"
            color="text__highlight"
            as="h2"
            marginBottom="medium"
            marginTop="xlarge"
          >
            1. Che cosa sono i cookie?
          </Typography>

          <Typography marginBottom="medium">
            Un cookie è una stringa composta unicamente di testo che un sito web
            trasferisce all’apposito file del browser sul disco rigido del
            vostro computer, in modo che il sito stesso possa memorizzare alcune
            informazioni su di voi. È il caso, ad esempio, delle pagine
            consultate, delle scelte operate nei menu, e di qualunque
            informazione eventualmente digitata nei moduli all’ora e nel giorno
            del collegamento al sito. Di per se stessi i cookie non possono
            essere utilizzati per identificare un utente.
          </Typography>

          <Typography
            variant="heading_2"
            color="text__highlight"
            as="h2"
            marginBottom="medium"
            marginTop="xlarge"
          >
            2. Tipi di cookie
          </Typography>

          <Typography marginBottom="medium">
            Ci sono due tipologie di cookie:
          </Typography>

          <S.List>
            <S.Item>
              <strong>cookie di sessione:</strong> questi sono i cookies
              temporanei che scadono alla fine di una sessione del browser,
              cioè, quando si lascia il sito. I cookies di sessione permettono
              al sito Web di riconoscere come vi spostate tra le pagine durante
              una sessione del browser e consentono di utilizzare il sito Web in
              modo più efficiente. Ad esempio, i cookie di sessione aiutano un
              sito Web a ricordare che un utente ha posto gli articoli in un
              carrello della spesa online.
            </S.Item>

            <S.Item>
              <strong>cookie permanenti:</strong> a differenza dei cookies di
              sessione, i cookies persistenti sono archiviati sul vostro
              computer anche al termine delle sessioni di navigazione e
              conservati fino alla scadenza o alla cancellazione. Essi
              consentono quindi al sito di "riconoscervi" al vostro ritorno e
              ricordare le vostre preferenze e personalizzazioni. Oltre ai
              cookies di sessione e cookies persistenti, ci possono essere altri
              i cookie impostati dal sito Web che avete scelto di visitare, al
              fine di fornire informazioni a noi o a terzi.
            </S.Item>
          </S.List>

          <Typography
            variant="heading_2"
            color="text__highlight"
            as="h2"
            marginBottom="medium"
            marginTop="xlarge"
          >
            3. Il nostro utilizzo dei cookie
          </Typography>

          <Typography marginBottom="medium">
            Attualmente utilizziamo, e potremmo utilizzare in futuro, i seguenti
            tipi di cookie su questo sito Web.
          </Typography>

          <Typography marginBottom="medium">
            Utilizziamo i cookie di sessione per:
          </Typography>

          <S.List>
            <S.Item>
              Aiutarci a mantenere la sicurezza e verificare i vostri dettagli
              migliorando la vostra esperienza sul nostro sito.
            </S.Item>
          </S.List>

          <Typography marginBottom="medium">
            Usiamo i cookie persistenti per:
          </Typography>

          <S.List>
            <S.Item>
              Raccogliere e compilare informazioni anonime, aggregate per
              statistica e scopi di valutazione per aiutarci a capire come gli
              utenti utilizzano il sito e aiutarci a migliorare la struttura del
              nostro sito Web.
            </S.Item>
          </S.List>

          <Typography marginBottom="medium">
            Molti cookies sono progettati per darvi un utilizzo ottimale del
            web. Per esempio, usiamo i cookies per consentirvi di migliorare la
            vostra esperienza di utenti quando utilizzate il nostro sito, (ad
            esempio un cookie riconosce se il vostro browser supporta una
            specifica funzionalità tecnologica). Questo aiuta, ad esempio, a
            caricare più velocemente le pagine web quando si richiede il
            download di file di grandi dimensioni.
          </Typography>

          <Typography marginBottom="medium">
            Oltre ai cookie che inviano informazioni a noi, utilizziamo anche
            cookies che raccolgono informazioni che vengono inviate a terzi un
            esempio di ciò è Google Analytics (per maggiori dettagli consultare:
            <>
              <a
                href="https://www.google.com/intl/it/policies/privacy/"
                target="_blank"
                rel="noreferrer noopener"
              >
                Google Privacy Policy
              </a>

              {' - '}
            </>
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=it"
              target="_blank"
              rel="noreferrer noopener"
            >
              Opt Out
            </a>
            ).
          </Typography>

          <Typography marginBottom="medium">
            Si prega di consultare il sito Web di terze parti per ulteriori
            informazioni circa il loro utilizzo dei cookies.
          </Typography>

          <Typography marginBottom="medium">
            Come con i cookie primari, potete bloccare i cookies di terze parti
            tramite le impostazioni del browser.
          </Typography>

          <Typography marginBottom="medium">
            Alcuni dei nostri cookies possono raccogliere e memorizzare
            informazioni personali quale indirizzo email. Ci impegniamo a
            rispettare e proteggere la vostra privacy e garantire che tutte le
            informazioni personali raccolte da noi saranno mantenute e trattate
            in conformità con la politica sulla privacy.
          </Typography>

          <S.List>
            <S.Item>Cookie analitici</S.Item>
          </S.List>

          <Typography marginBottom="medium">
            Questi cookie sono utilizzati per rilevare le prestazioni del sito
            web, le pagine visitate, il tempo di navigazione e altre
            informazioni utili per migliorare il sito stesso.
          </Typography>

          <Typography marginBottom="medium">
            Questa attività viene effettuata utilizzando Google Analytics, un
            servizio di web analytics fornito da Google.
          </Typography>

          <Typography marginBottom="medium">
            Le informazioni generate attraverso questi cookies circa l’utilizzo
            del sito da parte degli utenti sono anonime, dal momento che il
            Titolare ha richiesto e attivato la funzione di anonimizzazione
            degli indirizzi IP. Per tali motivi, il trattamento dei dati
            personali svolto attraverso i cookie del servizio Google Analytics
            non richiede il consenso degli utenti.
          </Typography>

          <Typography marginBottom="medium">
            Google può anche comunicare queste informazioni a terze parti, ove
            richiesto dalla legge, oppure se i dati sono trattati da dette terze
            parti per conto di Google.
          </Typography>

          <Typography marginBottom="medium">
            Per maggiori informazioni, è possibile consultare la&nbsp;
            <a
              href="https://support.google.com/analytics/answer/6004245?hl=it"
              target="_blank"
              rel="noreferrer noopener"
            >
              privacy policy del servizio Google Analytics
            </a>
            .
          </Typography>

          <Typography
            variant="heading_2"
            color="text__highlight"
            as="h2"
            marginBottom="medium"
            marginTop="xlarge"
          >
            Come disabilitare i cookies attraverso le impostazioni del browser
          </Typography>

          <Typography marginBottom="medium">
            È possibile gestire i cookie direttamente attraverso le impostazioni
            del browser. Cancellare i cookie dal browser potrebbe, tuttavia,
            comportare anche la cancellazione delle preferenze impostate in
            precedenza.
          </Typography>

          <Typography marginBottom="medium">
            La maggior parte dei browser sono impostati inizialmente per
            accettare i cookies. Tuttavia, avete la possibilità di disattivare i
            cookie, se lo desiderate, in generale cambiando le impostazioni di
            navigazione del vostro browser. Può anche essere possibile
            configurare le impostazioni del browser per abilitare l'accettazione
            di cookie specifici o per notificare ogni qualvolta un nuovo cookie
            sta per essere memorizzato sul vostro computer. Ciò vi permetterà di
            decidere se accettare o rifiutare i cookie. Per gestire l'utilizzo
            dei cookie ci sono varie risorse disponibili, ad esempio la sezione
            "Aiuto" del vostro browser può aiutarvi. È anche possibile
            disabilitare o eliminare i dati memorizzati e utilizzati da
            tecnologia simile ai cookie, ad esempio gli oggetti locali condivisi
            o Flash cookie, attraverso le impostazioni del browser o visitando
            il sito Web del relativo produttore.
          </Typography>

          <Typography marginBottom="medium">
            Per ulteriori informazioni e supporto, è anche possibile visitare la
            specifica pagina web del browser che stai utilizzando:
          </Typography>

          <S.List>
            <S.Item>
              <a
                href="https://support.google.com/chrome/answer/95647?hl=it-IT&hlrm=fr&hlrm=en"
                target="_blank"
                rel="noreferrer noopener"
              >
                Google Chrome
              </a>
            </S.Item>

            <S.Item>
              <a
                href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie"
                target="_blank"
                rel="noreferrer noopener"
              >
                Mozilla Firefox
              </a>
            </S.Item>

            <S.Item>
              <a
                href="https://support.microsoft.com/it-it/help/278835/how-to-delete-cookie-files-in-internetexplorer"
                target="_blank"
                rel="noreferrer noopener"
              >
                Internet Explorer
              </a>
            </S.Item>

            <S.Item>
              <a
                href="https://support.microsoft.com/it-it/help/4027947/microsoft-edge-delete-cookies"
                target="_blank"
                rel="noreferrer noopener"
              >
                Microsoft Edge
              </a>
            </S.Item>

            <S.Item>
              <a
                href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
                target="_blank"
                rel="noreferrer noopener"
              >
                Safari
              </a>
            </S.Item>
          </S.List>
        </Grid.Wrapper>
      </S.Wrapper>
    </>
  );
};
